<template>
    <div style="
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    background: #F0F5F4;
    scrollbar-width: none;
     -ms-overflow-style: none;">
        <div
            style="width: 100%;height: 50px;background: white;display: flex;align-items: center;justify-content: space-between;">
            <div @click="$router.back()" style="margin-left: 10px;cursor:pointer;">返回</div>
            <div style="font-weight: 700;">{{ chatRoomInfo ? chatRoomInfo.chatRoomName : '聊天' }}</div>
            <div @click="$router.push('/report/chat/'+chatRoomId)" style="margin-right:10px;color:#d98a00;cursor:pointer;">举报</div>
        </div>

        <section class="service-panel">
            <div class="service-head"><div><b>在线客服</b><small>请选择您要咨询的问题，或直接发送消息</small></div><button @click="$router.push('/orderList/-1')">服务进度 ›</button></div>
            <div class="quick-grid"><button v-for="question in quickQuestions" :key="question" @click="sendQuick(question)">{{ question }}<span>›</span></button></div>
        </section>
        <div ref="messageContainer" style="flex: 1;width: min(760px,99%);overflow: auto;-ms-overflow-style: none; scrollbar-width: none;">
            <div v-for="item, index in messageList" style="width: 100%;margin: 5px 0;" :key="index">
                <div style="display: flex;flex-direction: column;width: 100%;align-items: end;"
                    v-if="item.senderType == 0 && item.senderId == userInfo.id">
                    <div style="display: flex;align-items: center;">
                        <div style="margin-right: 10px;">{{ item.sendTime != null ? item.sendTime.replace(today, '') : '' }}
                        </div>
                        我
                    </div>
                    <div style="background: #F7E2DC;padding: 5px;flex-wrap: wrap;text-align: right;">{{ item.content }}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;width: 100%;align-items: start;" v-else>
                    <div style="display: flex;align-items: center;">
                        {{ chatRoomInfo ? chatRoomInfo.chatRoomName : '对方' }}
                        <div style="margin-left: 10px;">{{ item.sendTime != null ? item.sendTime.replace(today, '') : '' }}
                        </div>
                    </div>
                    <div style="background: #F7E2DC;padding: 5px;flex-wrap: wrap;text-align: left;">{{ item.content }}
                    </div>
                </div>
            </div>
        </div>

        <!-- 输入框 -->
        <div
            style="display: flex;align-items: flex-start;width: calc(100% - 20px);background: #F5F5F5;height: 50px;padding:  10px;">
            <input type="text" v-model="inputMessage"
                style="padding: 10px;flex: 1;margin-right: 10px;outline: 0;border: 0;">
            <el-button @click="sendMessage" type="primary">发送</el-button>
        </div>

    </div>

</template>
<script>
import request from "../axios/request";
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState(['messageList'])
    },
    watch: {
        // 深度监听 messageList 的变化
        messageList: {
            handler(newVal, oldVal) {
               
                this.scrollMessageBottom()
                // 这里可以执行一些数据变化后的操作
            },
            deep: true  // 深度监听
        }
    },
    data() {
        return {
            quickQuestions: ['商家长时间不发货','找不到订单','查询配送进度','我要申请退款','修改收货地址','如何联系商家'],
            inputMessage: null,
            userInfo: null,
            chatRoomId: null,
            chatRoomInfo: null,
            today: null
        }
    },
    destroyed() {
        
        this.$store.commit("clearMessageList");
    },
    mounted() {
        const currentDay = new Date();
        this.today =
            currentDay.getFullYear() + '/' +
            String(currentDay.getMonth() + 1).padStart(2, '0') + '/' +
            String(currentDay.getDate()).padStart(2, '0');
     

        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.chatRoomId = this.$route.params.chatRoomId;
        this.$store.commit("setCurrentRoomId", this.chatRoomId);
        const messageRoom = this.$store.state.messageRooms.get(this.chatRoomId)
        if (messageRoom!=null) {
            messageRoom.unread = 0
        }
        

        this.getRoomInfoByRoomId(this.chatRoomId);
    },
    methods: {
        sendQuick(question) { this.inputMessage = question; this.sendMessage() },
        scrollMessageBottom() {
            this.$nextTick(() => {
                const container = this.$refs.messageContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        async getRoomInfoByRoomId(roomId) {
            let res = await request({
                url: "/chat/api/getChatRoomInfoById",
                method: "get",
                params: {
                    chatRoomId: roomId,
                    currentType: 0
                }
            })
            if (res.data.status == 200) {
                this.chatRoomInfo = res.data.data.chatRoom;
                this.$store.state.messageList = res.data.data.chatMessageList
                this.initRoom();
            }
        },
        initRoom() {
            const timeoutId = setTimeout(() => {
                if (this.$store.state.socket != null) {
                    let mes = {
                        op: "initRoom",
                        roomId: this.chatRoomId,
                    }
                    this.$store.commit("sendMessage", JSON.stringify(mes))
                    clearInterval(timeoutId)
                }
            }, 3000);
        },
        sendMessage() {
            if (this.inputMessage == null || this.inputMessage == '') {
                return
            }

            this.messageList.push({
                senderType: 0,
                senderId: this.userInfo.id,
                content: this.inputMessage,
            })
            let mes = {
                op: "message",
                content: this.inputMessage,
                roomId: this.chatRoomId,
                senderType: 0,
                senderId: this.userInfo.id
            }
            this.$store.commit("sendMessage", JSON.stringify(mes))
            this.inputMessage = null
        }
    }
}
</script>
<style scoped>
.service-panel{width:min(760px,calc(100% - 24px));margin:12px auto 4px;background:#fff;border-radius:18px;padding:16px;box-sizing:border-box;box-shadow:0 6px 22px rgba(30,40,50,.06)}.service-head{display:flex;justify-content:space-between;align-items:center;text-align:left}.service-head b,.service-head small{display:block}.service-head b{font-size:18px}.service-head small{color:#999;margin-top:5px}.service-head button{border:0;background:transparent;color:#e5a900;cursor:pointer}.quick-grid{display:grid;grid-template-columns:repeat(3,1fr);margin-top:14px;border:1px solid #eee;border-radius:12px;overflow:hidden}.quick-grid button{display:flex;justify-content:space-between;border:0;border-right:1px solid #eee;border-bottom:1px solid #eee;background:#fff;padding:13px;text-align:left;cursor:pointer}.quick-grid button:hover{background:#fffbea}.quick-grid span{color:#999}@media(max-width:600px){.quick-grid{grid-template-columns:1fr 1fr}.service-panel{padding:13px}.service-head small{font-size:11px}}
</style>
